<script lang="ts">
  import { Col, Container, Row } from "sveltestrap";
  import BookmarkProductList from "./BookmarkProductList.svelte";
  import Card from "../../../Core/Card.svelte";
  import {
    DataTablesSearching,
    Individualcolumn,
  } from "../../../../utils/Constant/Constant";
  import DatatableProductList from "./DatatableProductList.svelte";
</script>

<BookmarkProductList />
<Container fluid>
  <Row>
    <Col sm="12">
      <Card cardHeaderprops="pb-0">
        <div slot="customheader">
          <h5>{Individualcolumn}</h5>
          <span>{DataTablesSearching}</span>
        </div>
        <div slot="contentbody">
          <div class="table-responsive product-table">
            <DatatableProductList />
          </div>
        </div>
      </Card>
    </Col>
  </Row>
</Container>
